var React = require('react');

function Integrations (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M16 7V3h-2v4h-4V3H8v4C7 7 6 8 6 9v5.5L9.5 18v3h5v-3l3.5-3.5V9c0-1-1-2-2-2Zm0 6.67-2.91 2.92-.42.41h-1.34l-.41-.41L8 13.67V9.09c0-.03.06-.09.09-.09h7.83c.03 0 .08.06.08.09v4.58Z"}));
}

Integrations.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = Integrations;

Integrations.default = Integrations;
